import Vue from 'vue';
import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import moment from 'moment';
import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
import { NotificationUrgency } from "@/enums/NotificationUrgency";
export default class InstructorsTableBase extends Vue {
    isCurrentUserInRow(row) {
        if (row.rowType === InstructorTableRowType.BLOCK) {
            return false;
        }
        return row.isCurrentUserRow();
    }
    findCellInRow(hour, row) {
        switch (row.rowType) {
            case InstructorTableRowType.BLOCK:
                return row.cells.find(x => x.hour === hour);
            case InstructorTableRowType.INSTRUCTOR:
                return row.cells.find(x => x.hour === hour);
        }
    }
    isModerator() {
        return this.$store.getters['user/isModerator'];
    }
    isAdmin() {
        return this.$store.getters['user/isAdmin'];
    }
    async updateDataSource() {
        await this.$store.dispatch('instructorTable/update', this.dataSource);
    }
    getDateTimeWithHours(date, hours) {
        return moment(date).hours(hours);
    }
    getAvailableHourCount(row, startHour) {
        let result = -1;
        if (row.rowType === InstructorTableRowType.BLOCK) {
            if (row.cells.some(x => x.hour > startHour)) {
                result = Math.min(...row.cells.filter(x => x.hour > startHour).map(x => x.hour)) - startHour;
            }
            else {
                result = this.dataSource.toHour - startHour + 1;
            }
        }
        else {
            result = 1;
            while (row.cells.some(x => x.hour === startHour + result && x.cellType === InstructorTableCellType.AVAILABLE)) {
                result++;
            }
        }
        return result;
    }
    getInstructorShortName(id) {
        const instructor = this.getInstructorById(id);
        return instructor.name.length > 18
            ? instructor.name.substr(0, 15) + '...'
            : instructor.name;
    }
    getInstructorAvatar(id) {
        return this.getInstructorById(id).avatar;
    }
    getInstructorFullName(id) {
        return this.getInstructorById(id).name;
    }
    getInstructorById(id) {
        const instructor = this.$store.getters['instructor/fullNames'].find((x) => x.id === id);
        return instructor ?? { id: 0, name: '', avatar: '' };
    }
    get notificationUrgency() {
        if (moment().add(1, 'days').isAfter(this.dataSource.date, 'hours')) {
            return NotificationUrgency.CRITICAL;
        }
        if (moment().add(3, 'days').isAfter(this.dataSource.date, 'hours')) {
            return NotificationUrgency.ALERT;
        }
        return NotificationUrgency.INFO;
    }
}
